import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=5f5145fc&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=5f5145fc&prod&lang=scss"
import style1 from "./Admin.vue?vue&type=style&index=1&id=5f5145fc&prod&scoped=true&lang=css"
import style2 from "./Admin.vue?vue&type=style&index=2&id=5f5145fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5145fc",
  null
  
)

export default component.exports